import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      batchStatuses: state => state.enumerations.batchStatuses,
      beneficiaryStatuses: state => state.enumerations.beneficiaryStatuses,
      channels: state => state.enumerations.channels,
      genders: state => state.enumerations.genders,
      phoneNumberTypes: state => state.enumerations.phoneNumberTypes,
      salutations: state => state.enumerations.salutations,
      ticketPriorities: state => state.enumerations.ticketPriorities,
      ticketStatuses: state => state.enumerations.ticketStatuses
    }),

    currencies: {
      get () {
        if (this.$store.state.enumerations.currencies.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'currencies' })
        }

        this.$store.state.enumerations.currencies.sort(function (a, b) {
          if (a.alpha3Code < b.alpha3Code) { return -1 }
          if (a.alpha3Code > b.alpha3Code) { return 1 }
          return 0
        })

        return this.$store.state.enumerations.currencies
      }
    },

    countries: {
      get () {
        if (this.$store.state.enumerations.countries.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'countries' })
        }

        return this.$store.state.enumerations.countries
      }
    },

    orderLineTypes: {
      get () {
        if (this.$store.state.enumerations.orderLineTypes.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'orderLineTypes' })
        }

        return this.$store.state.enumerations.orderLineTypes
      }
    },

    paymentMethods: {
      get () {
        if (this.$store.state.enumerations.paymentMethods.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'paymentMethods' })
        }

        return this.$store.state.enumerations.paymentMethods
      }
    },

    paymentStatuses: {
      get () {
        if (this.$store.state.enumerations.paymentStatuses.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'paymentStatuses' })
        }

        return this.$store.state.enumerations.paymentStatuses
      }
    },

    ticketTypes: {
      get () {
        if (this.$store.state.enumerations.ticketTypes.length === 0) {
          this.$store.dispatch('getEnumeration', { enumeration: 'ticketTypes' })
        }

        return this.$store.state.enumerations.ticketTypes
      }
    }
  }
}
